import { useBespokeSectionContext } from '../../primitives';
import { joinClasses } from '../../primitives/fieldClassSlots';
import { useLayoutDerived } from '../LayoutDerivedContext';
import { layoutInlineStyle } from '../layoutInlineStyle';
import type { LayoutNodeChildProps } from '../nodeRenderProps';
import type { ConditionalNode } from '../types';
import { RenderNodes } from '../renderNodes';
import { conditionalWhenSatisfied } from '../whenClause';

export function Conditional({
  node,
  answers,
  repeatBindings,
}: LayoutNodeChildProps<ConditionalNode>) {
  const { schemaMap } = useBespokeSectionContext();
  const derived = useLayoutDerived();
  if (
    !conditionalWhenSatisfied(node, answers, repeatBindings, derived, schemaMap)
  ) {
    return node.elseChildren ? (
      <div
        className={joinClasses('space-y-4', node.className)}
        style={layoutInlineStyle(node.style)}
      >
        <RenderNodes
          nodes={node.elseChildren}
          answers={answers}
          repeatBindings={repeatBindings}
        />
      </div>
    ) : null;
  }
  return (
    <div
      className={joinClasses('space-y-4', node.className)}
      style={layoutInlineStyle(node.style)}
    >
      <RenderNodes
        nodes={node.children}
        answers={answers}
        repeatBindings={repeatBindings}
      />
    </div>
  );
}
